import { K as head, D as pop, A as push, J as escape_html, I as attr } from "../../../chunks/index2.js";
import { H as Header } from "../../../chunks/Header.js";
import { m as meta_description, a as meta_keywords, t as title } from "../../../chunks/setup_link.js";
import "../../../chunks/runtime.js";
function _layout($$payload, $$props) {
  push();
  let { children } = $$props;
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>${escape_html(title())}</title>`;
    $$payload2.out.push(`<meta name="description"${attr("content", meta_description())}/> <meta name="keywords"${attr("content", meta_keywords())}/>`);
  });
  Header($$payload, {});
  $$payload.out.push(`<!----> `);
  children($$payload);
  $$payload.out.push(`<!---->`);
  pop();
}
export {
  _layout as default
};
